import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from './firebase';
import { USER_ROLES } from '../constants/roles';
import { assignMissingChildAccentKeys } from '../components/Dashboard/shared/childAccentTheme';

const MANAGER_ROLES = new Set([USER_ROLES.CARE_OWNER, USER_ROLES.CARE_PARTNER]);

export const persistMissingChildProfileColors = async (children = [], userId = '') => {
  const assignedChildren = assignMissingChildAccentKeys(children);
  const writes = [];

  const nextChildren = children.map((child, index) => {
    if (child?.profileColorKey || !MANAGER_ROLES.has(child?.userRole)) {
      return child;
    }

    const profileColorKey = assignedChildren[index].profileColorKey;
    writes.push(updateDoc(doc(db, 'children', child.id), {
      profileColorKey,
      updatedBy: userId,
      updatedAt: serverTimestamp(),
    }));
    return { ...child, profileColorKey };
  });

  await Promise.allSettled(writes);
  return nextChildren;
};
